<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Edit Village</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="village.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Postal Code
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="village.postal_code" />
                                    <validation-error :errors="apiValidationErrors.postal_code"  />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                ward
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-model="village.ward_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label="Ward"
                                        placeholder="Select Ward"
                                        :options="available_ward_dropdown"
                                        :allow-empty="false">
                                </select-input>
                                <validation-error :errors="apiValidationErrors.ward_id" />
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Village</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import SelectInput from '../../../components/Inputs/SelectInput';
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError, SelectInput },

    mixins: [formMixin],

    data: () => ({
        village: {
            type:'villages',
            name:null,
            postal_code:null,
            ward_id: null
        },
        available_ward_dropdown: []
    }),

    created () {
        this.get();
        this.getWardsDropDowns();
    },

    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('villages/get', id);
                this.attachmentType = this.$store.getters['villages/village'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            try {
                await this.$store.dispatch('villages/update', this.attachmentType);
                await this.$store.dispatch(
                    'alerts/success',
                    'Village updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        async getWardsDropDowns () {
            await this.$store.dispatch('wards/list');
            this.available_ward_dropdown =  await this.$store.getters['wards/list'];
        },
        goBack () {
            this.$router.push({ name: 'Villages List' });
        },
    },
};
</script>
